import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/ContactPage.css'; // Import your CSS file for styling

const ContactPage = () => {
    return (
        <main className="main-flex" role="main">
            <section>
                <h2>Contact Me</h2>
                <form id="contactForm" method="POST">
                    <label for="name">Name:</label><br />
                    <input type="text" id="name" name="name" placeholder = "Enter your name..." required /><br /><br />

                    <label for="email">Email:</label><br />
                    <input type="email" id="email" name="email" placeholder = "Etner your email..." required /><br /><br />

                    <label for="message">Message:</label><br />
                    <textarea id="message" name="message" rows="5" placeholder = "Write your message here..." required></textarea><br /><br />

                    <div className="hidden">
                        <input type="text" id="honeypot" name="honeypot" />
                    </div>

                    <button type="submit">Send</button>
                </form>
            </section>
        </main>
    );
};

export default ContactPage;